import { useState } from "react";

// Shows an MCP endpoint URL with a copy button and step-by-step instructions
// for connecting it in Claude (Code CLI + Desktop/web). Used on project pages
// (per-project endpoint) and the projects list (builder endpoint).
export function ConnectCard({
  url,
  title = "Connect to Claude",
  subtitle,
}: {
  url: string;
  title?: string;
  subtitle?: string;
}) {
  const [copied, setCopied] = useState(false);
  const [copiedCli, setCopiedCli] = useState(false);
  // Derive a short connector name from the URL's last path segment.
  const name = url.replace(/\/+$/, "").split("/").pop() || "mcpbuild";
  const cli = `claude mcp add --transport http ${name} ${url}`;

  const copy = (text: string, which: "url" | "cli") => {
    navigator.clipboard.writeText(text);
    if (which === "url") {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } else {
      setCopiedCli(true);
      setTimeout(() => setCopiedCli(false), 1500);
    }
  };

  return (
    <div className="rounded-lg border border-bg-2 bg-bg-1 p-4 space-y-3">
      <div className="flex items-center gap-2">
        <div className="text-fg-0 text-sm font-semibold mr-auto">{title}</div>
        <span className="text-[10px] font-mono uppercase tracking-wider text-accent">
          MCP
        </span>
      </div>
      {subtitle && <p className="text-fg-2 text-xs leading-relaxed">{subtitle}</p>}

      <div className="flex items-center gap-2">
        <code className="flex-1 bg-bg-2 border border-bg-2 rounded-md px-3 py-2 text-fg-0 text-xs font-mono break-all">
          {url}
        </code>
        <button
          onClick={() => copy(url, "url")}
          className="px-3 py-2 rounded-md bg-accent text-white text-xs hover:opacity-90 shrink-0"
        >
          {copied ? "copied" : "copy"}
        </button>
      </div>

      <details className="group">
        <summary className="cursor-pointer text-xs text-fg-2 hover:text-fg-0 select-none">
          How to connect ▾
        </summary>
        <div className="mt-3 space-y-3 text-xs text-fg-1">
          <div className="space-y-1">
            <div className="text-fg-2 uppercase tracking-wider text-[10px]">
              Claude Code (terminal)
            </div>
            <div className="flex items-center gap-2">
              <code className="flex-1 bg-bg-2 rounded px-2 py-1.5 font-mono break-all text-[11px]">
                {cli}
              </code>
              <button
                onClick={() => copy(cli, "cli")}
                className="px-2 py-1 rounded bg-bg-2 text-fg-1 text-[11px] hover:text-fg-0 shrink-0"
              >
                {copiedCli ? "copied" : "copy"}
              </button>
            </div>
          </div>
          <div className="space-y-1">
            <div className="text-fg-2 uppercase tracking-wider text-[10px]">
              Claude Desktop / claude.ai
            </div>
            <ol className="list-decimal list-inside space-y-0.5 text-fg-1">
              <li>Settings → Connectors → Add custom connector.</li>
              <li>Paste the URL above.</li>
              <li>
                Approve the sign-in — if you're signed into mcpbuild.app in this
                browser it's one click, no email.
              </li>
            </ol>
          </div>
        </div>
      </details>
    </div>
  );
}
